import { IPaginationDTO, ITeamDTO } from '@/dtos';
import {
  removeTeamFromYearAPI,
  addTeamsToYearAPI,
  getNextCriteriaNumberAPI,
  getTeamsTermsForYearAPI,
  getTeamsForYearWithSubmissionsAPI,
  getIncompleteTeamsForYearAPI,
} from '@/services/admin';

/* KEEP */
export async function getNextCriteriaNumber(yearId: string): Promise<number> {
  try {
    const response = await getNextCriteriaNumberAPI(yearId);
    return response;
  } catch {
    throw 'Error getting next criteria number';
  }
}
/* plan on removing */

export const getIncompleteTeamsForYear = async (
  yearId: string,
  pagination: IPaginationDTO,
): Promise<{ data: ITeamDTO[]; count: number }> => {
  try {
    const response = await getIncompleteTeamsForYearAPI(yearId, pagination);
    return response;
  } catch {
    throw 'Error getting Teams for Year';
  }
};

export async function getTeamsForYearWithSubmissions(body: any) {
  try {
    const response = await getTeamsForYearWithSubmissionsAPI(body);
    return response;
  } catch {
    return false;
  }
}

export async function getTeamsTermsForYear(yearId: string) {
  try {
    const response = await getTeamsTermsForYearAPI(yearId);
    return response;
  } catch {
    return false;
  }
}

export async function removeTeamFromYear(yearid: string, teamId: string) {
  try {
    const response = await removeTeamFromYearAPI(yearid, teamId);
    return response;
  } catch {
    return false;
  }
}

export async function addTeamsToYear(yearid: string, teams: any) {
  try {
    const ids: any = [];
    teams.forEach((obj: any) => ids.push(obj));
    const response = await addTeamsToYearAPI(yearid, { id: ids });
    return response;
  } catch {
    return false;
  }
}
